export const createProduct = `
    mutation createProduct($input: CreateProductInput!) {
        createProduct(input:$input) {
            id
            productTitle
            shortDescription
            longDescription
            productId
            productArn
            productCode
            status
            sku
            productLogoS3Url
            productVideoUrl
            highlightOne
            highlightTwo
            highlightThree
            productCategories
            keywordsForSearchResults
            meteringServiceSnsTopicArn
            created
            updated
    }
}`;

export const updateProduct = `
    mutation updateProduct($input: UpdateProductInput!) {
        updateProduct(input:$input){
            id
            productTitle
            shortDescription
            longDescription
            productId
            productArn
            productCode
            status
            sku
            productLogoS3Url
            productVideoUrl
            highlightOne
            highlightTwo
            highlightThree
            productCategories
            keywordsForSearchResults
            meteringServiceSnsTopicArn
            created
            updated
        }
}`;

export const deleteProduct = `
    mutation deleteProduct($input: DeleteProductInput!) {
        deleteProduct(input:$input) 
}`;
